export interface EmbedCatalogIdentity {
  readonly id: string;
  readonly slug: string;
}

export function resolveEmbedCatalogGame<TGame extends EmbedCatalogIdentity>(
  games: readonly TGame[],
  identifier: string,
): TGame | null {
  const normalized = identifier.trim();
  if (!normalized) return null;
  return games.find((game) => game.id === normalized || game.slug === normalized) ?? null;
}
